import { motion } from "motion/react";
import type { ReactNode } from "react";

const ease = [0.16, 1, 0.3, 1] as const;

/**
 * Card container used across dashboard pages. Entry animation plays once per
 * scroll-into-view; CSS transitions on padding keep the card smooth during
 * window resize + sidebar toggle without paying for per-frame layout JS.
 */
export function DashboardSection({
  title,
  titleRight,
  children,
  className,
  noPadding,
}: {
  title?: string;
  titleRight?: ReactNode;
  children: ReactNode;
  className?: string;
  noPadding?: boolean;
}): ReactNode {
  return (
    <motion.section
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.4, ease }}
      className={`rounded-2xl border border-border/40 bg-card transition-[padding] duration-200 ease-out ${noPadding ? "" : "p-4 sm:p-5 lg:p-6"} ${className ?? ""}`}
    >
      {title && (
        <div className={`flex flex-wrap items-center justify-between gap-2 ${noPadding ? "px-4 pt-4 sm:px-5 sm:pt-5 lg:px-6 lg:pt-6" : ""} mb-5 lg:mb-6`}>
          <h2 className="text-base font-light text-foreground">{title}</h2>
          {titleRight}
        </div>
      )}
      {children}
    </motion.section>
  );
}
